import { checkedTypes } from "constants/types";
import PropTypes from "prop-types";

// Types
export const docsProps = {
  id: PropTypes.number,
  occurrences: PropTypes.number,
  pos: PropTypes.number,
};

export const itemProps = {
  idx: PropTypes.number,
  id: PropTypes.string,
  occurrences: PropTypes.number,
  name: PropTypes.string,
  colour: PropTypes.string,
  description: PropTypes.string,
  checkState: PropTypes.oneOf([
    checkedTypes.CHECKED,
    checkedTypes.EMPTY,
    checkedTypes.INDETERMINATE,
  ]),
  docs: PropTypes.arrayOf(PropTypes.shape(docsProps)),
};

export const categoryProps = {
  id: PropTypes.number,
  occurrences: PropTypes.number,
  name: PropTypes.string,
  expanded: PropTypes.bool,
  description: PropTypes.string,
  colour: PropTypes.string,
  checkState: PropTypes.oneOf([
    checkedTypes.CHECKED,
    checkedTypes.EMPTY,
    checkedTypes.INDETERMINATE,
  ]),
  docs: PropTypes.arrayOf(PropTypes.shape(docsProps)),
  items: PropTypes.arrayOf(PropTypes.shape(itemProps)),
};
export const exportOrigin = {
  catShred: "categoryShred",
  simpleShred: "simpleShred",
  documents: "documents",
};

export const folderBy = {
  folder: "folder",
  document: "document",
};

export const HEADER_MULTIPLE = "Apply Dictionary to All Docs";
export const HEADER_SINGLE = "Change Dictionary";
export const DESCRIPTION_MULTIPLE = "Which dictionary do you want to apply?";
export const DESCRIPTION_SINGLE = "Click Dictionary below to select";
export const BUTTON_SINGLE = "Change Dictionary";
export const BUTTON_MULTIPLE = "Apply Dictionary";
